import React, { FC, useContext } from 'react';

import { Button, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';

import { MonthPicker } from 'molecules/Calendar/MonthRangePicker/MonthPicker';
import { StyledDateRangeFilterHeader } from 'organisms/Filter/forms/Form.styles';
import { FilterContext } from 'organisms/Filter/index';

const SingleMonthPickerFilter: FC<{ name: string }> = ({ name }) => {
  const { filter, setFilter } = useContext(FilterContext);
  const filterValue = filter[name];
  const value =
    typeof filterValue === 'string' && dayjs(filterValue, 'YYYY-MM').isValid()
      ? dayjs(filterValue, 'YYYY-MM').toDate()
      : null;

  return (
    <Stack>
      <StyledDateRangeFilterHeader>
        <Typography component="span">
          {value ? dayjs(value).format('MMMM YYYY') : 'Any month'}
        </Typography>
        <Button
          variant="text"
          disableRipple
          onClick={() => setFilter({ [name]: undefined })}
        >
          Reset
        </Button>
      </StyledDateRangeFilterHeader>
      <Stack alignItems="center">
        <MonthPicker
          value={value}
          onSelect={(date) =>
            setFilter({ [name]: dayjs(date).format('YYYY-MM') })
          }
        />
      </Stack>
    </Stack>
  );
};

export default SingleMonthPickerFilter;
